import { buildProps } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'
import type TimePicker from './time-picker.vue'

export const timePickerProps = buildProps({
  isGray: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type TimePickerProps = ExtractPropTypes<typeof timePickerProps>

// instance
export type TimePickerInstance = InstanceType<typeof TimePicker>
